//  import Vue from 'vue'
import store from '@/store'
import specialOffersCalc from '@/library/specialOffers'

export default {
  computed: {
    STATE () {
      return window.ctsautoconf.STATE
    },
    translationsLoading () {
      return store.getters['sbBetslipState/translationsLoading']
    },
    isGeoLocationEnabled () {
      return store.getters['sbBetslipState/isGeoLocationEnabled']
    },
    isLoggedIn () {
      return store.getters['isLoggedIn']
    },
    betslipSelectionsIds () {
      let selections = store.getters['sbBetslipState/betslipSelections']
      let ids = selections.map(s => s.idfoselection)
      return ids
    },
    tab () {
      return store.getters['sbBetslipState/tab']
    },
    betsNo () {
      return store.getters['sbBetslipState/selectionsNo']
    },
    gettingABTnR () {
      return store.getters['sbBetslipState/gettingABTnR']
    },
    currentBetSlipState () {
      return store.getters['sbBetslipState/currentBetSlipState']
    },
    currentBetSlipStateName () {
      return store.getters['sbBetslipState/currentBetSlipStateName']
    },
    betslipSelections () {
      // for debug
      return store.getters['sbBetslipState/betslipSelections']
    },
    betTypeStakes () {
      return store.getters['sbBetslipState/betTypeStakes']
    },
    returns () {
      // for debug
      return store.getters['sbBetslipState/returns']
    },

    allowedBetTypesAndReturns () {
      return store.getters['sbBetslipState/allowedBetTypesAndReturns']
    },
    betSlipTabs () {
      return store.getters['sbBetslipState/tabs']
    },
    betSlipChangeNo () {
      return store.getters['sbBetslipState/betSlipChangeNo']
    },
    inRunningDelay () {
      return store.getters['sbBetslipState/inRunningDelay']
    },
    gracePeriod () {
      return store.getters['sbBetslipState/gracePeriod']
    },
    bsCalculation () {
      return store.getters['sbBetslipState/bsCalculation']()
    },
    pitchers () {
      // for debug
      return store.getters['sbBetslipState/pitchers']
    },
    buyPoints () {
      // for debug
      return store.getters['sbBetslipState/buyPoints']
    },
    specialOffersBcEnabled () {
      return store.getters['sbBetslipState/specialOffersBcEnabled']
    },
    specialOfferData () {
      return store.getters['sbBetslipState/specialOfferData'] || {}
    },
    betSlipTotals () {
      // console.log('betSlipTotals')
      let totals = {
        betsCnt: 0,
        totalStake: 0,
        winning: 0,
        totalReturn: 0,
        soParlayBoost: 0,
        boostNames: [],
        insurance: []
      }
      if (this.bsCalculation && this.bsCalculation.betSlip && this.bsCalculation.betSlip.Bets && this.bsCalculation.betSlip.Bets.length) {
        totals.betsCnt = this.bsCalculation.betSlip.Bets.length
        this.bsCalculation.betSlip.Bets.forEach(bet => {
          totals.totalStake += bet.TotalStake
          totals.winning += bet.winning
          totals.totalReturn += bet.totalReturn
          //
          let soParlayBoosts = this.specialOffersBcEnabled && bet.betId && bet.SpecialOffers && bet.SpecialOffers[0] && bet.SpecialOffers[0].length && bet.SpecialOffers[0].filter(so => so.Id === 'PARLAYBOOST')
          // if (bet.BetTypeName === 'SGP' && bet.SpecialOffer && bet.SpecialOffer[0] && bet.SpecialOffer[0].length) {
          //   soParlayBoosts = this.specialOffersBcEnabled && bet.betId && bet.SpecialOffer && bet.SpecialOffer[0] && bet.SpecialOffer[0].length && bet.SpecialOffer[0].filter(so => so.Id === 'PARLAYBOOST')
          // }
          // let soParlayBoostBonus = soParlayBoost ? (soParlayBoost.Amount * bet.WinStake) : 0
          soParlayBoosts = soParlayBoosts || []
          for (let soParlayBoost of soParlayBoosts) {
            // console.log('Totals: ParlayBoosts')
            let soParlayBoostBonus = specialOffersCalc.calcSoBonus(soParlayBoost, bet.WinStake, 'betSlipTotals-ParlayBoost')
            totals.soParlayBoost += soParlayBoostBonus
            // if (soParlayBoostBonus) {
            totals.boostNames.push(soParlayBoost.Name)
            // }
          }
          //
          let insurance = this.specialOffersBcEnabled && bet.betId && bet.SpecialOffers && bet.SpecialOffers[0] && bet.SpecialOffers[0].length && bet.SpecialOffers[0].filter(so => so.Id === 'PARLAYINSURANCE')
          insurance = insurance || []
          for (let ins of insurance) {
            let soInsuranceBonus = specialOffersCalc.calcSoBonus(ins, bet.WinStake, 'betSlipTotals-Insurance')
            if (soInsuranceBonus === 0) {
              totals.insurance.push(ins.Name)
            }
          }
        })
        //
        totals.totalStake = parseFloat(totals.totalStake.toFixed(2))
        totals.winning = parseFloat(totals.winning.toFixed(2))
        totals.totalReturn = parseFloat(totals.totalReturn.toFixed(2))
        totals.soParlayBoost = parseFloat(totals.soParlayBoost.toFixed(2))
        totals.boostNames = [...new Set(totals.boostNames)]
        totals.insurance = [...new Set(totals.insurance)]
      }
      return totals
    },
    betPlacementResult () {
      return store.getters['sbBetslipState/betPlacementResponse']
    },
    betSlipStatus () {
      return store.getters['sbBetslipState/betSlipStatus']
    },
    interRelated () {
      return store.getters['sbBetslipState/interRelated']
    },
    allowedMultiSingles () {
      return store.getters['sbBetslipState/allowedMultiSingles']
    },
    inRefferal () {
      return store.getters['sbBetslipState/inRefferal']
    },
    promotionsData () {
      return store.getters['sbBetslipState/promotionsData'] || []
    },
    promotionsPayload () {
      // return store.getters['sbBetslipState/promotionsPayload']((this.bsCalculation && this.bsCalculation.betSlip) || {})
      return (this.bsCalculation && this.bsCalculation.promotionPayload && this.bsCalculation.promotionPayload.payload) || []
    },
    promotionsPayloadKey () {
      // var self = this
      var key = [this.tab]
      if (this.isLoggedIn && this.promotionsPayload && this.promotionsPayload.length) {
        this.promotionsPayload.forEach(function (p) {
          key.push(p.split(',').slice(0, 3).join(','))
        })
      }
      return key.join(';')
    },
    getApplicableVouchers () {
      return store.getters['sbBetslipState/getApplicableVouchers'] || false
    },
    isLiveWireConnected () {
      return store.getters['livebettingState/isLiveWireConnected']
    },
    selectionToggledIn () {
      return store.getters['sbBetslipState/selectionToggledIn']
    }
  },

  methods: {
    setTab (tab) {
      if (this.currentBetSlipState) {
        return
      }
      store.commit('sbBetslipState/setTab', tab)
//        this.dismissBetSlip(null, !true)
    },
    clearBetSlip () {
      store.dispatch('sbBetslipState/clearBetSlip')
    },
    setTabFromBetSlip (tab) {
      this.$emit('setTabFromBetSlip', tab)
    },
    fetchPromotions () {
      if (this.getApplicableVouchers) {
        return
      }
      var self = this
      clearTimeout(this.fetchPromotionsTo)
      this.fetchPromotionsTo = setTimeout(function () {
        store.dispatch('sbBetslipState/triggerFetchPromotions', {promotionPayload: self.bsCalculation.promotionPayload})
      }, 0)
    }
  },

  created () {
  },

  mounted () {
  },

  watch: {
    promotionsPayloadKey: {
      immediate: true,
      handler (v, ov) {
//         console.log('Watch promotionsPayload ov: ' + ov)
//         console.log('Watch promotionsPayload nv: ' + v)
//         console.log('Different: ' + (v !== ov))
        this.fetchPromotions()
      }
    }
  },

  destroyed () {
  }
}



// WEBPACK FOOTER //
// ./src/components/sports/BetSlipV2/mixins/BetSlip.js